import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import Team from "@/modules/settings/teams";
import { CategoriesType } from "@/types/settings/drivers";
import { Response } from "@/interface/response.interface";

const Teams = {
  namespaced: true,
  state: () => ({
    list: [],
    totalRows: 0,
    team: {},
    success: false,
    message: "",
  }),
  getters: {
    list: (state: any) => state.list,
    totalRows: (state: any): number => state.totalRows,
    team: (state: any) => state.team,
    success: (state: any) => state.success,
    message: (state: any) => state.message,
  },
  mutations: {
    SET_TEAMS_LIST(state: any, payload: any) {
      state.list = payload.list;
      state.totalRows = payload.count;
    },
    SET_TEAMS_RESULT(state: any, payload: any) {
      state.team = payload.team;
      state.success = payload.success;
      state.message = payload.message;
    },
  },
  actions: {
    /**
     * get teams
     * @param commit
     */
    async getTeams({ commit }: { commit: any }) {
      return await request
        .get<Response<Array<CategoriesType>>>(`${ENDPOINTS.TEAMS}`)
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          const list = data.map((item) => new Team(item));
          await commit("SET_TEAMS_LIST", { list, count });
        })
        .catch(async (error) => {
          console.log(error);
        });
    },
    /**
     * create team the body should have name an array of location ids with minimum one location id
     * @param commit
     * @param team
     * @constructor
     */
    async CreateTeam({ commit }: { commit: any }, team) {
      return await request
        .post(`${ENDPOINTS.TEAMS}`, team)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_TEAMS_RESULT", {
              team: new Team(data),
              success: true,
              message: data.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_TEAMS_RESULT", { team: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },
    /**
     * delete a team
     * @param commit
     * @param teamId
     */
    async deleteTeam({ commit }: { commit: any }, teamId) {
      return await request
        .delete(`${ENDPOINTS.TEAM_DELETE(teamId)}`)
        .then((response) => response.data)
        .catch(async (error) => {
          console.log(error);
        });
    },

    /**
     * delete  a teams using array of id's
     * @param commit
     * @param driverId
     */
    async bulkDeleteTeams({ commit }: { commit: any }, data) {
      return await request
        .delete(`${ENDPOINTS.TEAMS_BATCH}`, { data })
        .then((response) => response.data)
        .catch(async (error) => {
          console.log(error);
        });
    },

    /**
     * edit  teams by bulk
     * @param commit
     * @param driverId
     */

    async bulkEditTeams({ commit }: { commit: any }, data) {
      return await request
        .patch(`${ENDPOINTS.TEAMS_BATCH}`, data)
        .then((response) => response.data)
        .catch(async (error) => {
          console.log(error);
        });
    },

      /**
     * edit  a teams using array of id's
     * @param commit
     * @param driverId
     */

       async bulkCreateTeams({ commit }: { commit: any }, data) {
        return await request
          .post(`${ENDPOINTS.TEAMS_BATCH}`, data)
          .then((response) => response.data)
          .catch(async (error) => {
            console.log(error);
          });
      },

  },
};
export default Teams;
